import { render, staticRenderFns } from "./JdiPlaceholder.vue?vue&type=template&id=3d748817&scoped=true&"
import script from "./JdiPlaceholder.vue?vue&type=script&lang=ts&"
export * from "./JdiPlaceholder.vue?vue&type=script&lang=ts&"
import style0 from "./JdiPlaceholder.vue?vue&type=style&index=0&id=3d748817&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d748817",
  null
  
)

export default component.exports